/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-plusplus */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/require-default-props */
import React, {
  Dispatch,
  ReactElement,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from 'react'

import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  CheckOutlined,
  CloseOutlined,
  DeleteOutlined,
  WarningOutlined,
} from '@ant-design/icons'
import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  InputNumber,
  PageHeader,
  Radio,
  RadioChangeEvent,
  Result,
  Row,
  Skeleton,
  Slider,
  Table,
  TimePicker,
  Typography,
} from 'antd'
import { CheckboxChangeEvent } from 'antd/lib/checkbox'
import { SelectFieldAnt } from 'Components/Form'
import DateSelector from 'Components/Form/DateSelector'
import { SelectItemProps } from 'Components/Form/Select'
import ID_COMPONENTE from 'config/idComponente'
import { UsuarioGrupo } from 'Models/cadastros'
import {
  IArmazem,
  IMacro,
  IMacroPermitida,
  IMacroPermitidaBase,
  IMacroTipo,
} from 'Models/docas'
import IArmazemTipo from 'Models/docas/IArmazemTipo'
import IFormArmazemInput from 'Models/docas/IFormArmazemInput'
import moment from 'moment'
import { useForm } from 'react-hook-form'
import WsDocasService from 'Services/WS_DOCAS'

import { DocasContext } from '../Context/context'

interface IProps {
  armazemSelecionado?: IArmazem
  setTela: Dispatch<SetStateAction<string>>
  getArmazens: () => Promise<void>
}

const CadastroEdicaoArmazem = ({
  armazemSelecionado,
  setTela,
  getArmazens,
}: IProps): ReactElement => {
  const calculaTotalHoras = (horarios?: any) => {
    const horariosAux =
      horarios || !armazemSelecionado
        ? horarios
        : [
            moment(armazemSelecionado.horaInicioFuncionamento, 'HH:mm:ss'),
            moment(armazemSelecionado.horaFimFuncionamento, 'HH:mm:ss'),
          ]

    let totalHoras = 24

    if (horariosAux) {
      //totalHoras = horariosAux[1].diff(horariosAux[0], 'hours', true)

      const difHoras: number = horariosAux[1].diff(
        horariosAux[0],
        'hours',
        true,
      )

      totalHoras = window.parseFloat(difHoras.toFixed(2))
    }

    return totalHoras
  }

  const { docasContext, setDocasContext } = useContext(DocasContext)

  const [result, setResult] = useState<number>(0)
  const [resultError, setResultError] = useState<string>('')
  const { Paragraph } = Typography
  const [horarioFuncionamentoSelecionado, setHorarioFuncionamentoSelecionado] =
    useState<boolean>(false)
  const [qtdMinimaJanelasPrimarias] = useState<number>(1)
  const [qtdMaximaJanelasPrimarias, setQtdMaximaJanelasPrimarias] =
    useState<number>(8)
  const [formulario] = Form.useForm<IFormArmazemInput>()
  const [opcoesJanelasPrimarias, setOpcoesJanelasPrimarias] = useState<any>()
  const [tamanhoJanelaSecundaria, setTamanhoJanelaSecundaria] =
    useState<number>(60)
  const [tamanhoMinimoJanelaSecundaria] = useState<number>(15)
  const [tamanhoMaximoJanelaSecundaria] = useState<number>(135)
  const [medidaJanelaSecundaria] = useState<number>(15)
  const [marcadoresJanelasSecundarias, setMarcadoresJanelasSecundarias] =
    useState<any>()
  const [totalHoras, setTotalHoras] = useState<number>(calculaTotalHoras())
  const hookForm = useForm()
  const [macros, setMacros] = useState<IMacro[]>([])
  const [macrosDisponiveis, setMacrosDisponiveis] = useState<IMacro[]>([])
  const [selectMacroDisponivelItens, setSelectMacroDisponivelItens] = useState<
    SelectItemProps[]
  >([])

  const [selectTipoMacroItens, setSelectTipoMacroItens] = useState<
    SelectItemProps[]
  >([])
  const [selectUsuarioGrupoItens, setSelectUsuarioGrupoItens] = useState<
    SelectItemProps[]
  >([])
  const [selectTipoArmazemItens, setSelectTipoArmazemItens] = useState<
    SelectItemProps[]
  >([])
  const [carregandoEdicaoArmazem, setCarregandoEdicaoArmazem] =
    useState<boolean>(false)
  const [processandoFormulario, setProcessandoFormulario] =
    useState<boolean>(false)
  const [cdMacroTipoSelecionado, setCdMacroTipoSelecionado] =
    useState<string>('1')
  const [macrosPermitidas, setMacrosPermitidas] = useState<IMacroPermitida[]>(
    [],
  )
  const [macrosPermitidasAnteriores, setMacrosPermitidasAnteriores] = useState<
    IMacroPermitida[]
  >([])
  const [adicionandoMacro, setAdicionandoMacro] = useState<boolean>(false)
  const [cdMacroSelecionada, setCdMacroSelecionada] = useState<number>()
  const [macroSelecionadaObrigatoria, setMacroSelecionadaObrigatoria] =
    useState<boolean>(false)

  const getMacros = async () => {
    const { data } = await WsDocasService.macro.getList(ID_COMPONENTE.DOCAS)

    if (data.items) {
      setMacros(data.items)
    }
  }

  const getTiposMacro = async () => {
    const { data } = await WsDocasService.macro.getTiposMacro(
      ID_COMPONENTE.DOCAS,
    )

    if (data.items) {
      const selectTiposMacroData: SelectItemProps[] = data.items.map(
        (item: IMacroTipo) => {
          return {
            value: item.cdMacro.toString(),
            label: item.nome,
          }
        },
      )

      setSelectTipoMacroItens(selectTiposMacroData)
    }
  }

  const getUsuariosGrupos = async () => {
    const { data } = await WsDocasService.misc.getUsuariosGrupos(
      ID_COMPONENTE.DOCAS,
    )

    if (data.items) {
      const selectUsuariosGruposData: SelectItemProps[] = data.items.map(
        (item: UsuarioGrupo) => {
          return {
            value: item.cdUsuarioGrupo.toString(),
            label: item.nome,
          }
        },
      )

      setSelectUsuarioGrupoItens(selectUsuariosGruposData)
    }
  }

  const getTiposArmazens = async () => {
    const { data } = await WsDocasService.armazem.getListTypes(
      ID_COMPONENTE.DOCAS,
    )

    if (data.items) {
      const selectTiposArmazemData: SelectItemProps[] = data.items.map(
        (item: IArmazemTipo) => {
          return {
            value: item.cdAgendamentoDocasArmazemTipo.toString(),
            label: item.descricao,
          }
        },
      )

      setSelectTipoArmazemItens(selectTiposArmazemData)
    }
  }

  const defineMarcadoresJanelasSecundarias = () => {
    const marcadores: any = {}

    if (tamanhoMinimoJanelaSecundaria <= 30) {
      marcadores[30] = 'meia hora'
    }

    for (let i = 60; i <= tamanhoMaximoJanelaSecundaria; i += 30) {
      const horas: number = i / 60
      const horasInteiras: number = Math.trunc(horas)

      marcadores[i] = horasInteiras + (horasInteiras === 1 ? ' hora' : ' horas')

      if (horas > horasInteiras) {
        marcadores[i] += ' e meia'
      }
    }

    setMarcadoresJanelasSecundarias(marcadores)
  }

  const buscaUltimaConfiguracao = async (armazemSelecionado: IArmazem) => {
    setCarregandoEdicaoArmazem(true)

    const { data } = await WsDocasService.armazem.getFutureConfigurations(
      ID_COMPONENTE.DOCAS,
      armazemSelecionado.cdAgendamentoDocasArmazem,
    )

    const cdsUsuariosGrupos: string[] = armazemSelecionado.cdsUsuariosGrupos
      .filter((cdUsuarioGrupo) => cdUsuarioGrupo !== 1) //O grupo master da Compuletra não deve aparecer
      .map((cdUsuarioGrupo) => cdUsuarioGrupo.toString())

    let armazemInput: IFormArmazemInput

    if (data.items && data.items.length > 0) {
      const ultimaConfiguracao: IArmazem = data.items[data.items.length - 1]

      if (ultimaConfiguracao.cdMacroTipo) {
        setCdMacroTipoSelecionado(ultimaConfiguracao.cdMacroTipo.toString())
      } else if (armazemSelecionado.cdMacroTipo) {
        setCdMacroTipoSelecionado(armazemSelecionado.cdMacroTipo.toString())
      }

      armazemInput = {
        nomeArmazem:
          ultimaConfiguracao.nomeArmazem ?? armazemSelecionado.nomeArmazem,
        ativo: armazemSelecionado.ativo,
        cdAgendamentoDocasArmazemTipo:
          ultimaConfiguracao.cdAgendamentoDocasArmazemTipo.toString() ??
          armazemSelecionado.cdAgendamentoDocasArmazemTipo.toString(),
        docasUteis:
          ultimaConfiguracao.docasUteis ?? armazemSelecionado.docasUteis,
        qtdJanelasPrimarias:
          ultimaConfiguracao.qtdJanelasPrimarias ??
          armazemSelecionado.qtdJanelasPrimarias,
        funcionamento:
          ultimaConfiguracao.horaInicioFuncionamento &&
          ultimaConfiguracao.horaFimFuncionamento
            ? [
                moment(ultimaConfiguracao.horaInicioFuncionamento, 'HH:mm:ss'),
                moment(ultimaConfiguracao.horaFimFuncionamento, 'HH:mm:ss'),
              ]
            : [
                moment(armazemSelecionado.horaInicioFuncionamento, 'HH:mm:ss'),
                moment(armazemSelecionado.horaFimFuncionamento, 'HH:mm:ss'),
              ],
        dataInicioMoment: moment(
          ultimaConfiguracao.dtInicio,
          'DD/MM/YYYY HH:mm:ss',
        ),
        cdMacroTipo: cdMacroTipoSelecionado,
        tempoJanelaMinutos: ultimaConfiguracao.tempoJanelaMinutos,
        cdsUsuariosGrupos: cdsUsuariosGrupos,
        gerenciaCota: ultimaConfiguracao.gerenciaCota,
      }

      if (ultimaConfiguracao.macrosPermitidas) {
        setMacrosPermitidas([...ultimaConfiguracao.macrosPermitidas])
        setMacrosPermitidasAnteriores([...ultimaConfiguracao.macrosPermitidas])
      } else {
        setMacrosPermitidas([])
        setMacrosPermitidasAnteriores([])
      }

      setTimeout(() => {
        alert(
          'Você está visualizando os dados de uma edição que ainda não foi aplicada. Se você editar novamente, a edição atual será sobreescrita.',
        )
      }, 500)
    } else {
      armazemInput = {
        nomeArmazem: armazemSelecionado.nomeArmazem,
        ativo: armazemSelecionado.ativo,
        cdAgendamentoDocasArmazemTipo:
          armazemSelecionado.cdAgendamentoDocasArmazemTipo.toString(),
        docasUteis: armazemSelecionado.docasUteis,
        qtdJanelasPrimarias: armazemSelecionado.qtdJanelasPrimarias,
        funcionamento: [
          moment(armazemSelecionado.horaInicioFuncionamento, 'HH:mm:ss'),
          moment(armazemSelecionado.horaFimFuncionamento, 'HH:mm:ss'),
        ],
        dataInicioMoment: moment().add(1, 'days'),
        cdMacroTipo: armazemSelecionado.cdMacroTipo?.toString(),
        tempoJanelaMinutos: armazemSelecionado.tempoJanelaMinutos,
        cdsUsuariosGrupos: cdsUsuariosGrupos,
        gerenciaCota: armazemSelecionado.gerenciaCota,
      }

      if (armazemSelecionado.macrosPermitidas) {
        setMacrosPermitidas([...armazemSelecionado.macrosPermitidas])
        setMacrosPermitidasAnteriores([...armazemSelecionado.macrosPermitidas])
      } else {
        setMacrosPermitidas([])
        setMacrosPermitidasAnteriores([])
      }
    }

    formulario.setFieldsValue(armazemInput)

    setCarregandoEdicaoArmazem(false)
  }

  const calculaQtdJanelasSecundarias = (qtdJanelasPrimarias: number) => {
    const qtdReal: number =
      totalHoras / qtdJanelasPrimarias / (tamanhoJanelaSecundaria / 60)

    return Math.round(qtdReal)
  }

  const converteMacrosPermitidasParaBase = (macros: IMacroPermitida[]) => {
    const macrosCopia: IMacroPermitida[] = [...macros]

    const macrosBase: IMacroPermitidaBase[] = []

    for (let i = 0; i < macros.length; i++) {
      macrosBase.push({
        cdMacro: macrosCopia[i].cdMacro,
        ordem: macrosCopia[i].ordem,
        obrigatoria: macrosCopia[i].obrigatoria,
      })
    }

    return macrosBase
  }

  const cadastraOuEditaArmazem = async (armazemInput: IFormArmazemInput) => {
    setProcessandoFormulario(true)

    try {
      const docas = []

      for (let i = 0; i < armazemInput.docasUteis; i++) {
        docas.push({
          nomeDoca: `Doca ${i + 1}`,
          status: 1,
          funcao: 0,
        })
      }

      const janelas = []

      for (let i = 0; i < armazemInput.qtdJanelasPrimarias; i++) {
        janelas.push({
          nomeJanela: `Janela ${i + 1}`,
        })
      }

      const macrosPermitidasBaseAnteriores: IMacroPermitidaBase[] =
        converteMacrosPermitidasParaBase(macrosPermitidasAnteriores)

      const macrosPermitidasBaseNovas: IMacroPermitidaBase[] =
        converteMacrosPermitidasParaBase(macrosPermitidas)

      const atualizaMacros: boolean =
        JSON.stringify(macrosPermitidasBaseAnteriores) !==
        JSON.stringify(macrosPermitidasBaseNovas)

      const armazem = {
        cdArmazem: armazemSelecionado?.cdAgendamentoDocasArmazem,
        cdAgendamentoDocasArmazemTipo: window.parseInt(
          armazemInput.cdAgendamentoDocasArmazemTipo,
        ),
        cdPontoEntidadeUnidade: 0,
        cdPontoEntidadeArmazem: 0,
        dataInicio: armazemSelecionado
          ? armazemInput.dataInicioMoment.format('YYYY-MM-DD HH:mm:ss')
          : undefined,
        nomeArmazem: armazemInput.nomeArmazem,
        ativo: armazemInput.ativo,
        funcionamentoInicio: {
          horas: parseInt(armazemInput.funcionamento[0].format('HH')),
          minutos: parseInt(armazemInput.funcionamento[0].format('mm')),
        },
        funcionamentoFim: {
          horas: parseInt(armazemInput.funcionamento[1].format('HH')),
          minutos: parseInt(armazemInput.funcionamento[1].format('mm')),
        },
        docas,
        janelas,
        qtdJanelasSecundarias: calculaQtdJanelasSecundarias(
          armazemInput.qtdJanelasPrimarias,
        ),
        criarAutomatico: true,
        cdMacroTipo: cdMacroTipoSelecionado,
        tempoJanelaMinutos: tamanhoJanelaSecundaria,
        cdsUsuariosGrupos: armazemInput.cdsUsuariosGrupos,
        gerenciaCota: armazemInput.gerenciaCota,
        macrosPermitidas: macrosPermitidasBaseNovas,
        atualizaMacros: atualizaMacros,
      }

      try {
        const { data } = armazemSelecionado
          ? await WsDocasService.armazem.update(ID_COMPONENTE.DOCAS, armazem)
          : await WsDocasService.armazem.create(ID_COMPONENTE.DOCAS, armazem)

        if (data.statusCode == 501) {
          await getArmazens()
          setDocasContext({ ...docasContext, refreshArmazem: new Date() })
          setResult(200)
        } else {
          setResult(400)
          if (data.message) {
            setResultError(data.message)
          }
        }
      } catch (e) {
        console.error(e)

        setResult(400)
        setResultError(
          'Verifique se você preencheu todos os campos corretamente',
        )
      }
    } catch (e) {
      console.error(e)
    }

    setProcessandoFormulario(false)
  }

  const alteraOpcoesJanelasPrimarias = (horarios: any) => {
    const numHoras: number = calculaTotalHoras(horarios)
    let qtdMaximaOpcoes = 1

    if (numHoras !== totalHoras) {
      setTotalHoras(numHoras)
    }

    const opcoes: any = {}
    opcoes[1] = 1

    for (let i = 2; i < numHoras; i++) {
      if (numHoras % i === 0) {
        opcoes[i] = i
        qtdMaximaOpcoes = i
      }
    }

    setOpcoesJanelasPrimarias(opcoes)
    setQtdMaximaJanelasPrimarias(qtdMaximaOpcoes)

    const dadosFormulario = formulario.getFieldsValue()

    if (!opcoes[dadosFormulario.qtdJanelasPrimarias]) {
      dadosFormulario.qtdJanelasPrimarias = 1
      formulario.resetFields()
      formulario.setFieldsValue(dadosFormulario)
    }

    if (!horarioFuncionamentoSelecionado) {
      setHorarioFuncionamentoSelecionado(true)
    }
  }

  const alteraOrdemMacro = (ordemOriginal: number, incremento: number) => {
    const ordemNova: number = ordemOriginal + incremento

    if (ordemNova >= 1 && ordemNova <= macrosPermitidas.length) {
      const macrosOrdenadas: IMacroPermitida[] = [...macrosPermitidas]

      macrosOrdenadas[ordemOriginal - 1].ordem = ordemNova
      macrosOrdenadas[ordemNova - 1].ordem = ordemOriginal

      macrosOrdenadas.sort((macro1: IMacroPermitida, macro2: IMacroPermitida) =>
        macro1.ordem > macro2.ordem ? 1 : -1,
      )

      setMacrosPermitidas(macrosOrdenadas)
    }
  }

  const alteraObrigatoriedadeMacro = (cdMacro: number) => {
    const macrosAtualizadas: IMacroPermitida[] = [...macrosPermitidas]

    const macroAtualizada: IMacroPermitida | undefined = macrosAtualizadas.find(
      (macro) => macro.cdMacro === cdMacro,
    )

    if (macroAtualizada) {
      macroAtualizada.obrigatoria = !macroAtualizada.obrigatoria
      setMacrosPermitidas(macrosAtualizadas)
    } else {
      window.alert(
        'Ocorreu um erro ao atualizar a obrigatoriedade da macro, atualize a página e tente novamente',
      )
    }
  }

  const preparaAdicaoMacro = () => {
    if (!adicionandoMacro) {
      if (selectMacroDisponivelItens.length > 0) {
        setCdMacroSelecionada(undefined)
        setMacroSelecionadaObrigatoria(false)
        formulario.setFieldsValue({ cdMacroSelecionada: undefined })

        setAdicionandoMacro(true)
      } else {
        window.alert('Todas as macros disponíveis já foram adicionadas')
      }
    }
  }

  const adicionaMacro = (cdMacro: number, obrigatoria: boolean) => {
    let macroSelecionada: IMacro | undefined = macros.find(
      (macro) => macro.cdMacro == cdMacro,
    )

    if (macroSelecionada) {
      macroSelecionada = { ...macroSelecionada }

      const macrosAtualizadas: IMacroPermitida[] = [...macrosPermitidas]

      const novaMacro: IMacroPermitida = {
        cdAgendamentoDocasArmazemConfig:
          armazemSelecionado?.cdAgendamentoDocasArmazemConfig,
        cdMacro: macroSelecionada.cdMacro!,
        nome: macroSelecionada.nome!,
        ordem: macrosAtualizadas.length + 1,
        obrigatoria: obrigatoria,
        ativo: true,
      }

      macrosAtualizadas.push(novaMacro)

      setMacrosPermitidas(macrosAtualizadas)

      setAdicionandoMacro(false)
    } else {
      window.alert(
        'Ocorreu um erro ao adicionar a macro, atualize a página e tente novamente',
      )
    }
  }

  const removeMacro = (macro: IMacroPermitida) => {
    let macrosAtualizadas: IMacroPermitida[] = [...macrosPermitidas]

    macrosAtualizadas = macrosAtualizadas.filter(
      (_macro) => _macro.cdMacro !== macro.cdMacro,
    )

    for (let i = 0; i < macrosAtualizadas.length; i++) {
      macrosAtualizadas[i].ordem = i + 1
    }

    setMacrosPermitidas(macrosAtualizadas)
  }

  const verificaMacrosDisponiveis = () => {
    let macrosAtualizadas: IMacro[] = []

    if (macrosPermitidas.length > 0) {
      if (macrosAtualizadas.length < macros.length) {
        for (let i = 0; i < macros.length; i++) {
          const macroEstaDisponivel = !macrosPermitidas.some(
            (macro) => macro.cdMacro === macros[i].cdMacro,
          )

          if (macroEstaDisponivel) {
            macrosAtualizadas.push(macros[i])
          }
        }
      }
    } else {
      macrosAtualizadas = [...macros]
    }

    const opcoesMacrosAtualizadas: SelectItemProps[] = macrosAtualizadas.map(
      (item: IMacro) => {
        return {
          value: item.cdMacro!.toString(),
          label: item.nome!,
        }
      },
    )

    setMacrosDisponiveis(macrosAtualizadas)
    setSelectMacroDisponivelItens(opcoesMacrosAtualizadas)
  }

  useEffect(() => {
    getMacros()
    getTiposMacro()
    getUsuariosGrupos()
    getTiposArmazens()
    defineMarcadoresJanelasSecundarias()
  }, [])

  useEffect(() => {
    verificaMacrosDisponiveis()
  }, [macrosPermitidas])

  useEffect(() => {
    if (armazemSelecionado) {
      buscaUltimaConfiguracao(armazemSelecionado)

      if (armazemSelecionado.tempoJanelaMinutos) {
        setTamanhoJanelaSecundaria(armazemSelecionado.tempoJanelaMinutos)
      }

      alteraOpcoesJanelasPrimarias([
        moment(armazemSelecionado.horaInicioFuncionamento, 'HH:mm:ss'),
        moment(armazemSelecionado.horaFimFuncionamento, 'HH:mm:ss'),
      ])
    } else {
      formulario.setFieldsValue({ ativo: true })
    }
  }, [armazemSelecionado])

  return (
    <>
      <PageHeader
        ghost={false}
        title={armazemSelecionado ? 'Editar Armazém' : 'Cadastrar Armazém'}
        extra={[
          <Button key="1" type="text" onClick={() => setTela('')}>
            <CloseOutlined />
          </Button>,
        ]}
      />
      {result === 0 ? (
        <Form
          layout="vertical"
          onFinish={cadastraOuEditaArmazem}
          form={formulario}
          initialValues={{ tempoJanelaMinutos: tamanhoJanelaSecundaria }}
        >
          <Row>
            <Paragraph></Paragraph>
            {/* <Paragraph>{mensagemEdicao}</Paragraph> */}
          </Row>
          <Skeleton loading={carregandoEdicaoArmazem} active>
            <Row align="middle" gutter={16} style={{ width: '100%' }}>
              <Col span={armazemSelecionado ? 12 : 24}>
                <Form.Item
                  label="Nome:"
                  name="nomeArmazem"
                  rules={[
                    {
                      required: true,
                      message: 'Campo obrigatório!',
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>

              {armazemSelecionado ? (
                <Col span={12}>
                  <DateSelector
                    label="Data para Aplicar a Edição:"
                    name="dataInicioMoment"
                    currentTime={false}
                    showTime={false}
                    validRange={[
                      moment().add(1, 'days'),
                      moment().add(30, 'days'),
                    ]}
                    rules={[
                      {
                        required: true,
                        message: 'Campo obrigatório!',
                      },
                    ]}
                  />
                </Col>
              ) : null}
            </Row>

            <Row align="middle" gutter={16} style={{ width: '100%' }}>
              <Col span={12}>
                <SelectFieldAnt
                  methods={hookForm}
                  scope="form-armazem"
                  label="Tipo:"
                  name="cdAgendamentoDocasArmazemTipo"
                  items={selectTipoArmazemItens}
                  showSearch={true}
                  rules={[
                    {
                      required: true,
                      message: 'Campo obrigatório!',
                    },
                  ]}
                />
              </Col>

              <Col span={12}>
                <Form.Item
                  label="Gerencia Cota:"
                  name="gerenciaCota"
                  rules={[
                    {
                      required: true,
                      message: 'Campo obrigatório!',
                    },
                  ]}
                >
                  <Radio.Group>
                    <Radio value={true}>Sim</Radio>
                    <Radio value={false}>Não</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
            </Row>

            <Row align="middle" gutter={16} style={{ width: '100%' }}>
              <Col span={12}>
                <Form.Item
                  label="Número de Docas:"
                  name="docasUteis"
                  rules={[
                    {
                      required: true,
                      message: 'Campo obrigatório!',
                    },
                  ]}
                >
                  <InputNumber min={1} value={1} style={{ width: '100%' }} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="Horário de Funcionamento:"
                  name="funcionamento"
                  rules={[
                    {
                      required: true,
                      message: 'Campo obrigatório!',
                    },
                  ]}
                >
                  <TimePicker.RangePicker
                    format={'HH:mm'}
                    onChange={alteraOpcoesJanelasPrimarias}
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row align="middle" style={{ width: '98%' }}>
              <Col span={24}>
                <Form.Item
                  label="Quantidade de Janelas Primárias:"
                  name="qtdJanelasPrimarias"
                  rules={[
                    {
                      required: true,
                      message: 'Campo obrigatório!',
                    },
                  ]}
                >
                  <Slider
                    min={qtdMinimaJanelasPrimarias}
                    max={qtdMaximaJanelasPrimarias}
                    marks={opcoesJanelasPrimarias}
                    step={null}
                    disabled={!horarioFuncionamentoSelecionado}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row align="middle" style={{ width: '98%' }}>
              <Col span={24}>
                <Form.Item
                  label="Tamanho das Janelas Secundárias:"
                  name="tempoJanelaMinutos"
                  rules={[
                    {
                      required: true,
                      message: 'Campo obrigatório!',
                    },
                  ]}
                >
                  <Slider
                    style={{ width: '95%' }}
                    min={tamanhoMinimoJanelaSecundaria}
                    max={tamanhoMaximoJanelaSecundaria}
                    marks={marcadoresJanelasSecundarias}
                    step={medidaJanelaSecundaria}
                    onChange={setTamanhoJanelaSecundaria}
                    defaultValue={tamanhoJanelaSecundaria}
                    value={tamanhoJanelaSecundaria}
                    disabled={!horarioFuncionamentoSelecionado}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row align="middle" style={{ width: '98%' }}>
              <Col span={24}>
                <SelectFieldAnt
                  methods={hookForm}
                  scope="form-armazem"
                  label="Tipo de Macro:"
                  name="cdMacroTipo"
                  items={selectTipoMacroItens}
                  showSearch={true}
                  defaultValue={cdMacroTipoSelecionado}
                />
              </Col>
            </Row>

            <Row align="middle" gutter={16} style={{ width: '100%' }}>
              <Col span={24}>
                <Table
                  size="small"
                  pagination={false}
                  dataSource={macrosPermitidas}
                  columns={[
                    {
                      title: (
                        <span style={{ textAlign: 'center' }}>Opções</span>
                      ),
                      key: 'opcoes',
                      dataIndex: 'ordem',
                      width: '105px',
                      render: (ordem: number, macro: IMacroPermitida) => (
                        <>
                          <span
                            style={{ cursor: 'pointer' }}
                            title="Alterar ordem"
                            onClick={() => alteraOrdemMacro(ordem, -1)}
                          >
                            <ArrowUpOutlined />
                          </span>

                          <span
                            style={{ cursor: 'pointer', marginLeft: '10px' }}
                            title="Alterar ordem"
                            onClick={() => alteraOrdemMacro(ordem, 1)}
                          >
                            <ArrowDownOutlined />
                          </span>

                          <span
                            style={{ cursor: 'pointer', marginLeft: '10px' }}
                            title="Alterar obrigatoriedade"
                            onClick={() =>
                              alteraObrigatoriedadeMacro(macro.cdMacro)
                            }
                          >
                            <WarningOutlined />
                          </span>

                          <span
                            style={{ cursor: 'pointer', marginLeft: '10px' }}
                            title="Remover"
                            onClick={() => removeMacro(macro)}
                          >
                            <DeleteOutlined />
                          </span>
                        </>
                      ),
                    },
                    {
                      title: 'Ordem',
                      key: 'ordem',
                      dataIndex: 'ordem',
                      width: '60px',
                    },
                    {
                      title: 'Obrigatória',
                      key: 'obrigatoria',
                      dataIndex: 'obrigatoria',
                      width: '65px',
                      render: (obrigatoria: boolean) =>
                        obrigatoria ? 'Sim' : 'Não',
                    },
                    {
                      title: 'Nome',
                      key: 'nome',
                      dataIndex: 'nome',
                    },
                  ]}
                />
                <Button type="primary" onClick={() => preparaAdicaoMacro()}>
                  Adicionar macro
                </Button>

                {adicionandoMacro && (
                  <>
                    <Row
                      align="middle"
                      gutter={16}
                      style={{ width: '100%', marginTop: '10px' }}
                    >
                      <Col span={18}>
                        <SelectFieldAnt
                          methods={hookForm}
                          scope="form-macro"
                          name="cdMacroSelecionada"
                          showSearch={true}
                          onChangeValue={(value: string) =>
                            setCdMacroSelecionada(window.parseInt(value))
                          }
                          items={selectMacroDisponivelItens}
                        />
                      </Col>

                      <Col span={4} style={{ marginTop: '-27px' }}>
                        <Checkbox
                          onChange={(e: CheckboxChangeEvent) =>
                            setMacroSelecionadaObrigatoria(
                              !macroSelecionadaObrigatoria,
                            )
                          }
                        >
                          Obrigatória
                        </Checkbox>
                      </Col>
                    </Row>

                    <Row
                      align="middle"
                      gutter={16}
                      style={{ width: '100%', marginTop: '-20px' }}
                    >
                      <Col span={4}>
                        <Button
                          type="primary"
                          disabled={!cdMacroSelecionada}
                          onClick={() =>
                            adicionaMacro(
                              cdMacroSelecionada!,
                              macroSelecionadaObrigatoria,
                            )
                          }
                        >
                          Confirmar
                        </Button>
                      </Col>

                      <Col span={4} style={{ marginLeft: '5px' }}>
                        <Button
                          type="primary"
                          onClick={() => setAdicionandoMacro(false)}
                          danger
                        >
                          Cancelar
                        </Button>
                      </Col>
                    </Row>
                  </>
                )}
              </Col>
            </Row>

            {armazemSelecionado ? (
              <Row align="middle">
                <Col
                  span={24}
                  style={{
                    marginTop: '20px',
                    marginBottom: '10px',
                    fontWeight: 'bold',
                  }}
                >
                  As configurações abaixo serão aplicadas imediatamente:
                </Col>
              </Row>
            ) : null}

            <Row align="middle" gutter={16} style={{ width: '100%' }}>
              <Col span={17}>
                <SelectFieldAnt
                  methods={hookForm}
                  scope="form-usuario-grupo"
                  label="Grupos de Usuários Vinculados:"
                  name="cdsUsuariosGrupos"
                  items={selectUsuarioGrupoItens}
                  showSearch={true}
                  mode="multiple"
                  rules={[
                    {
                      required: true,
                      message: 'Campo obrigatório!',
                    },
                  ]}
                />
              </Col>

              <Col span={7}>
                <Form.Item
                  name="ativo"
                  label="Situação:"
                  rules={[
                    {
                      required: true,
                      message: 'Campo obrigatório!',
                    },
                  ]}
                >
                  <Radio.Group>
                    <Radio value={true}>Ativo</Radio>
                    <Radio value={false}>Inativo</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
            </Row>

            <Row align="middle">
              <Col>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={processandoFormulario}
                >
                  {armazemSelecionado ? 'Salvar' : 'Cadastrar'}
                </Button>
              </Col>
            </Row>
          </Skeleton>
        </Form>
      ) : (
        <>
          {result === 200 ? (
            <Result
              status="success"
              title={
                'Armazém ' +
                (armazemSelecionado ? 'editado' : 'criado') +
                ' com sucesso!'
              }
              extra={
                !armazemSelecionado
                  ? [
                      <Button
                        type="primary"
                        key="console"
                        onClick={() => setResult(0)}
                      >
                        Adicionar outro armazém
                      </Button>,
                    ]
                  : null
              }
            />
          ) : (
            <Result
              status="error"
              title={
                'Não foi possível ' +
                (armazemSelecionado ? 'editar' : 'criar') +
                ' o armazém.'
              }
              subTitle={resultError}
              extra={[
                <Button
                  type="primary"
                  key="console"
                  onClick={() => setResult(0)}
                >
                  Tentar novamente
                </Button>,
              ]}
            />
          )}
        </>
      )}
    </>
  )
}

export default CadastroEdicaoArmazem
